import { configureStore } from '@reduxjs/toolkit';
import controlSidebarReducer from './reducers/control-sidebar';
import countryReducer from './reducers/country-reducer';
import languageReducer from './reducers/language-reducer';

import titleReducer from './reducers/title-reducer';

const store = configureStore({
    reducer: {
        headerTitle: titleReducer,
        controlSidebar: controlSidebarReducer,
        language: languageReducer,
        countries: countryReducer
    }
});
export default store;